import cn from 'classnames';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import calendarIcon from 'assets/images/properties/calendar-event.svg';
import mapPointIcon from 'assets/images/properties/map-point.svg';
import { ReturnComponentType } from 'common';
import { CommonDataCard } from 'components';
import { DateFormat, Paths } from 'enums';
import { InspectionType } from 'state';
import './InspectionHistory.scss';
import { capitalizeWord } from 'utils';

type InspectionHistoryType = {
  inspection: InspectionType;
  address?: string;
  className?: string;
};

export const InspectionHistory = ({
  inspection,
  className,
  address,
}: InspectionHistoryType): ReturnComponentType => {
  const navigate = useNavigate();
  const onInspectionClick = () => {
    navigate(`${Paths.INSPECTIONS}/${inspection.id}`);
  };

  return (
    <CommonDataCard className={cn('InspectionHistory', className)}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div onClick={onInspectionClick} style={{ cursor: 'pointer' }}>
        <section className="InspectionHistory_Title">
          <span className="InspectionHistory_Title_Dot" />
          {inspection?.name ?? '-'}
          <span className={`InspectionHistory_Title_Label_${inspection?.status}`}>
            {capitalizeWord(inspection?.status) ?? '-'}
          </span>
        </section>

        <section className="InspectionHistory_Body">
          <img
            src={calendarIcon}
            alt="calendar-icon"
            className="InspectionHistory_Body_Icon"
          />
          <div className="InspectionHistory_Body_Date">
            {inspection?.createdAt
              ? dayjs(inspection?.createdAt).format(DateFormat.GENERAL)
              : '-'}
          </div>

          <div className="InspectionHistory_Body_Name">
            <img
              src={mapPointIcon}
              alt="map-point-icon"
              className="InspectionHistory_Body_Name_Icon"
            />
            {address ?? '-'}
          </div>
        </section>
      </div>
    </CommonDataCard>
  );
};
